<template>
  <div class="mission-ranking-page">
    <mission-ranking-pane />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import MissionRankingPane from '@/components/MissionPage/MissionRankingPane.vue'

export default defineComponent({
  name: 'MissionRankingPage',
  components: { MissionRankingPane },
})
</script>

<style lang="scss" scoped>
.mission-ranking-page {
  height: 100%;
  overflow: hidden;
}
</style>
